<template>
    <div class="bg-base" style="min-width: 1200px">
      <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'HotelWrap'
    }
</script>
